// StoryProgress extraction - text only, no design influence
// This module is ONLY used for storyProgress navigation and never includes design elements

export function extractStoryProgressContent(resultData, totalPages) {
  const pagesArray = resultData?.Pages || resultData?.['Pages:'] || [];
  console.log('📑 Found pages array:', pagesArray);
  
  const newContent = Array(totalPages).fill('');
  
  pagesArray.forEach(page => {
    const pageNumber = page?.Page || page?.page;
    const pageContent = page?.Content || page?.content;
    
    if (pageNumber > 0 && pageNumber <= totalPages && pageContent) {
      newContent[pageNumber - 1] = pageContent;
      console.log(`📝 Setting page ${pageNumber} content:`, pageContent.substring(0, 50) + '...');
    } else {
      console.log('⚠️ Skipping invalid page:', page);
    }
  });
  
  if (newContent.some(c => c)) {
    console.log('🎉 StoryProgress content extracted successfully');
    return newContent;
  }
  
  return null;
}
